module.exports = __webpack_public_path__ + "static/img/f6.ccb7f45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/f6.png
// module id = hs7Y
// module chunks = 1